import { NodeModel } from "../_model/NodeModel";
import { DecorationCondenser } from "./decorationCondenser";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class Condenser extends NodeModel {
  constructor() {
    super("Condenser");

    this.type = new Types().Condenser;
    this.x = 0;
    this.y = 0;
    this.xImg = () => this.x + 2;
    this.yImg = () => this.y + 2;
    this.height = 140;
    this.width = 130;
    this.operationSelected = "";
    this.srcImg = require("@/assets/Fluxogramas/aquecedor.png");
    this.data = [new Properties({ ...this })];
    this.jokerCaption = [];

    this.decorate = async function(callback) {
      this.decorator = new DecorationCondenser();
      await this.decorator.init(this, callback);
    };

    /* Métodos para serem implementados */

    this.clone = () => {
      let cloned = new Condenser();
      //cloned = { ...this, decorator: null }
      cloned.id = this.id;
      cloned.idName = this.idName;
      cloned.type = this.type;
      cloned.x = this.x;
      cloned.y = this.y;
      cloned.height = this.height;
      cloned.width = this.width;
      cloned.decorator = null;
      cloned.readOnly = this.readOnly
      cloned.expressionVisible = this.expressionVisible
      cloned.jokerCaption = this.jokerCaption;
      cloned.data = this.data.map((d) => d.clone());

      return cloned;
    };

    this.copyFrom = (node) => {
      this.simpleCopyFrom(node);
      this.jokerCaption = node.jokerCaption;
      this.data = node.data.map((d) => new Properties({ ...d }));
    };

    this.update = (node) => {
      if (node.attrs) {
        this.data = node.attrs;
      }
      this.expressionVisible = node.expressionVisible;
    };

    this.rebuildStructure = (newProps = []) => {
      let newData = [];
      this.jokerCaption = [];

      newProps.forEach(prop => {
        let equipments = prop.subType == "Equipamentos" && prop.key == "Status";
        
        if (equipments) {
          newData.push(prop);
        }
        
      });
      this.data = newData;
    }

    // Para caso o nó tenha connections.
    // this.removeConnection = (connectionId) => {
    //   this.connectionPack = this.connectionPack.filter(connection => connection.conn.id != connectionId)
    // }
  }
}

export { Condenser };
